import o from"lodash/cloneDeep";import r from"lodash/merge";var e={layout:"horizontal"},t=function(t){return r(o(e),o(t))};export{e as default,t as mergeTimelineConfigs};
